import { create } from 'zustand';

import { ComparisonSortBy } from '@/api/model';

import { ComparisonStore, ComparisonView } from './use-comparison.model';

const INITIAL_COMPARISON_STATE = {
  activeView: 'findings' as ComparisonView,
  addendumExpandedByStudyId: {} as Record<string, boolean>,
  finalImpressionsExpandedByStudyId: {} as Record<string, boolean>,
  isOpen: false,
  priorStudyId: null as null | string,
  sortBy: 'organ' as ComparisonSortBy,
};

export const useComparisonStore = create<ComparisonStore>((set) => ({
  ...INITIAL_COMPARISON_STATE,
  close: () => set({ isOpen: false }),
  open: (priorStudyId?: string) =>
    set((state) => ({
      isOpen: true,
      priorStudyId: priorStudyId ?? state.priorStudyId,
    })),
  reset: () => set(INITIAL_COMPARISON_STATE),
  setAddendumExpanded: ({ isExpanded, studyId }) =>
    set((state) => ({
      addendumExpandedByStudyId: {
        ...state.addendumExpandedByStudyId,
        [studyId]: isExpanded,
      },
    })),
  setFinalImpressionsExpanded: ({ isExpanded, studyId }) =>
    set((state) => ({
      finalImpressionsExpandedByStudyId: {
        ...state.finalImpressionsExpandedByStudyId,
        [studyId]: isExpanded,
      },
    })),
  setPriorStudy: (priorStudyId: string) => set({ priorStudyId }),
  setSortBy: (sortBy: ComparisonSortBy) => set({ sortBy }),
  setView: (activeView: ComparisonView) => set({ activeView }),
}));
